var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxDimensions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 110,
    viewBox: "0 0 99 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#A7A6A6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-width",
    d: "M65.926 101.767l-7.949 2.115v-3.44L57.93 100l-1.55.415V110l1.597-.433v-4.091l8.437-2.243zM86.39 93.002l-1.526.411v3.548l-6.942 1.866-.47 1.76 7.412-1.993V102l1.619-.443V93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-length",
    d: "M21.26 101.966l-19.514-1.608v-3.227L.188 97v7.87l1.558.13v-3.182l19.514 1.608zM51.802 101v3.978l-22.514-1.906v1.502l22.514 1.918v3.373l1.568.135v-8.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.368 0h-.07L16.821 2.47.188 5.125v87.73L54.45 97.99l.11.011 31.924-7.538-.544-87.86L32.369 0zm0 1.318L78.83 3.577l-8.898 1.4-46.592-2.21 9.03-1.449zm21.458 6.185L7.283 5.328l9.683-1.538 46.516 2.197-9.656 1.516zM1.515 6.371l51.694 2.417.634 87.817-52.328-4.948V6.371zM55.17 96.5l-.635-87.768 30.086-4.73.529 85.42-29.98 7.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.163 48.468l-16.89-18.253a.672.672 0 0 0-.96-.024L10.42 46.734a.662.662 0 0 0-.153.715.669.669 0 0 0 .6.423l8.613.443v22.803a.667.667 0 0 0 .616.665L35.377 73h.054c.37 0 .67-.298.67-.665V49.15l8.544.432a.67.67 0 0 0 .633-.38.662.662 0 0 0-.106-.728l-.01-.007zm-9.707-.683a.671.671 0 0 0-.703.665v23.164L20.81 70.506V47.67a.667.667 0 0 0-.635-.665l-7.731-.384 15.314-15L43.07 48.17l-7.614-.386z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-height",
    d: "M90.497 43v8h1.826v-3.21h3.37V51h1.828v-8h-1.827v3.165h-3.37V43zM89.493 3v1.56h3.899V40h1.573V4.56h3.559V3zM94.965 53h-1.573v35.44h-3.899V90h9.031v-1.56h-3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-width",
    d: "M65.411 98.852l1.871-.443 1.646 5.52 1.779-6.358 1.496-.354 1.78 5.51 1.644-6.296L77.452 96l-2.712 9.436-1.518.36-1.792-5.285-1.791 6.13-1.518.359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d-length",
    d: "M23.267 99l1.843.216v6.642l4.178.47V108l-6.02-.686z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDimensions);
export default __webpack_public_path__ + "static/media/box-dimensions.f0001e7a.svg";
export { ForwardRef as ReactComponent };